import { IoCContainer, IUtils, WebCoreIoCKeys } from '../../../web-core';

export class SettingsBackupModel {
    id?: number;
    settingName?: string;
    password?: string;
    settings?: string;
    extensionName?: string;
    version?: string;

    constructor(settingsBackupJSObj?: any) {
        let utils: IUtils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        if (settingsBackupJSObj != null) {
            utils.deepCopy(this, settingsBackupJSObj);
        }
    }
}
